var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.notifications),function(notification){return _c('p',{domProps:{"innerHTML":_vm._s(notification.description)}})}),_vm._v(" "),(!_vm.notifications)?_c('div',{staticClass:"text-center"},[_vm._v("\n\t\t"+_vm._s(_vm.t.user.notfound.notifications)+"\n\t")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078d1110","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account/notifications.vue
// module id = mqP9
// module chunks = 0